module.exports = __webpack_public_path__ + "static/media/student40.09fada71.png";